// checks if app is running on client side or server side
export const isBrowser = !!(
  (typeof window !== 'undefined' &&
    window.document && window.document.createElement)
);

// check if application is bimeh or whitelabel
// export const isBimeh = !!(process.env.APP === 'bimeh')
export const isBimeh = false

// check if is in development mode
export const isDevelopment = !!(process.env.NODE_ENV === 'development');
// TODO: shoud be custom hooknpm
